import { ApiResourceBaseClass as e } from "./baseApiCalls.js";
const a = "place_action_links";
class n extends e {
  /**
   * Get list of available Place Action Links, and their translations into `lang`.
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/place_action_links`
   *
   * @param {string} lang - Language to translate the Place Action Link names into. If not provided, the user's default language will be used.
   * @returns {GetPlaceActionLinksForBusinessReceivedData} List of available Place Action Links, and their translations into `lang`.
   */
  getPlaceActionLinks = async (s) => {
    const { data: t } = await this.get(
      `${a}`,
      s ? { lang: s } : {}
    );
    return t;
  };
}
export {
  n as PlaceActionLinks
};
